import { useEffect } from "react"

export function useTitle(title) {
    useEffect(() => {
        const prevTitle = document.title
        document.title = `Parq.ai - ${title}`
        return () => {
            document.title = prevTitle
        }
    }, [title])
}